import React, {useState} from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Chip,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography
} from "@material-ui/core";
// import PlayArrow from "@material-ui/icons/PlayArrow";
import CalendarToday from "@material-ui/icons/CalendarToday";
// import AccessTime from "@material-ui/icons/AccessTime";
import Close from "@material-ui/icons/Close";
import GetApp from "@material-ui/icons/GetApp";

import RyanTaftAvatar from "../../assets/img/sales_training/ryan_taft_avatar.png";
import Impact88 from "../../assets/img/sales_training/impact_88_logo.png";
import SSELogo from "../../assets/img/sales_training/sse-logo.png";
import ChanceDorseyAvatar from "../../assets/img/sales_training/chance_dorsey_avatar.png";
import KimberlyMackeyAvatar from "../../assets/img/sales_training/Kimberly_Mackey_avatar.jpg";
import NHSLogo from "../../assets/img/sales_training/newhomessolutions_logo.jpg";

import useStyles from "./styles";

interface IVideo {
  id: string;
  title: string;
  description: string;
  thumbnail: string;
  videoUrl: string;
  duration: string;
  date: string;
  category: string;
  creator: {
    name: string;
    title: string;
    description: string;
    avatar: string;
    company: string;
    companyUrl: string;
    companyLogo: string;
    invertLogoColors: boolean;
  };
}

const SalesTraining = () => {
  const classes = useStyles();
  const [selectedVideo, setSelectedVideo] = useState<IVideo | null>(null);
  const [showConsultation, setShowConsultation] = useState(false);
  const [activeTab] = useState("all");

  const videos: IVideo[] = [
    {
      id: "1",
      title: "Best Practices for NterNow Lead Follow-up",
      description:
        "Learn proven techniques to establish trust and convert leads into buyers with effective follow-up strategies.",
      thumbnail: `https://img.youtube.com/vi/bjnFacXst5w/hqdefault.jpg`,
      videoUrl: "https://www.youtube.com/embed/bjnFacXst5w?si=Pgd57OAebPAC03zj",
      duration: "15 minutes",
      date: "March 26, 2025",
      category: "Lead Conversion",
      creator: {
        name: "Ryan Taft",
        title: "Sales Training Expert",
        description:
          "Ryan Taft is a renowned sales trainer with over 15 years of experience in the real estate and property technology industries. He specializes in lead conversion strategies and customer relationship management.",
        avatar: RyanTaftAvatar,
        company: "Impact Eighty Eight",
        companyUrl: "https://www.impacteightyeight.com/",
        companyLogo: Impact88,
        invertLogoColors: false
      }
    },
    {
      id: "2",
      title:
        "How to Follow Up with NterNow Leads Like a Pro | Sales Solve Everything",
      description:
        "Learn how to effectively follow up with self-tour leads using a proven framework that shifts from cold outreach to meaningful conversations that build trust and close deals.",
      thumbnail: `https://img.youtube.com/vi/B6vcBiCa6Mo/hqdefault.jpg`,
      videoUrl: "https://www.youtube.com/embed/B6vcBiCa6Mo?si=NAn-9D8ORwrIkBCn",
      duration: "9 minutes",
      date: "July 10, 2025",
      category: "Lead Conversion",
      creator: {
        name: "Chance Dorsey",
        title: "Sales Coach & Consultant",
        description:
          "Chance Dorsey has almost two decades of diverse experience in four different divisions of a top national homebuilder. He specializes in evaluating sales skillsets and crafting training programs that position teams for success, with a proven track record of building and motivating top-producing new home sales teams.",
        avatar: ChanceDorseyAvatar,
        company: "Sales Solve Everything",
        companyUrl: "https://salessolveeverything.com/",
        companyLogo: SSELogo,
        invertLogoColors: true
      }
    },
    {
      id: "2",
      title:
        "Founder",
      description:
        "Not just sales training. New Homes Solutions is the company you call when you want predictable, profitable sales. We make sure your processes, procedures, and systems support your sales effort to ensure that sales is the engine that drives your train, rather than running it off the tracks. If you are struggling in this market, give us a call. The initial consultation costs you nothing.",
      thumbnail: `https://img.youtube.com/vi/MP3d6KTrNq4/hqdefault.jpg`,
      videoUrl: "https://www.youtube.com/embed/MP3d6KTrNq4?si=NAn-9D8ORwrIkBCn",
      duration: "9 minutes",
      date: "July 24, 2025",
      category: "Lead Conversion",
      creator: {
        name: "Kimberly Mackey",
        title: "Founder & Sales Strategy Expert",
        description:
          "Kimberly Mackey is the founder of New Homes Solutions and a nationally recognized sales and marketing expert in the home building industry. With over 20 years of executive experience, she helps builders and real estate professionals create effective sales strategies and training programs. A sought-after speaker and author, Kimberly has held key leadership roles with the NAHB and FHBA and is widely known as the “expert with real-world solutions.",
        avatar: KimberlyMackeyAvatar,
        company: "New Homes Solutions",
        companyUrl: "https://newhomessolutions.com",
        companyLogo: NHSLogo,
        invertLogoColors: false
      }
    }
  ];

  const filteredVideos =
    activeTab === "all"
      ? videos
      : videos.filter(
          video => video.category.toLowerCase() === activeTab.toLowerCase()
        );

  // const handleTabChange = (event: any, newValue: any) => setActiveTab(newValue);

  const handleSubmitConsultation = (e: any) => {
    e.preventDefault();
    alert("Consultation request submitted!");
    setShowConsultation(false);
  };

  const getLogoClass = (video: IVideo) => {
    return video.creator.invertLogoColors
      ? classes.companyLogoInverted
      : classes.companyLogo;
  };

  return (
    <div className={classes.root}>
      <Container className={classes.container}>
        <Box className={classes.header}>
          <Typography variant="h1" className={classes.heading} gutterBottom>
            New Construction Sales Training
          </Typography>
          <Typography variant="h6" className={classes.subheading}>
            Master the art of selling new construction homes with our expert
            video training series
          </Typography>
        </Box>

        {/*<Box className={classes.tabsWrapper}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            centered
            className={classes.TabsX}
          >
            <Tab className={classes.tabRoot} label="All Videos" value="all"/>
            <Tab
              className={classes.tabRoot}
              label="Lead Conversion"
              value="lead conversion"
            />
            <Tab
              className={classes.tabRoot}
              label="Sales Techniques"
              value="sales techniques"
            />
            <Tab
              className={classes.tabRoot}
              label="Marketing"
              value="marketing"
            />
            <Tab
              className={classes.tabRoot}
              label="Sales Strategies"
              value="sales strategies"
            />
          </Tabs>
        </Box>*/}

        <Grid container spacing={4}>
          {filteredVideos.map(video => (
            <Grid item xs={12} md={6} key={video.id}>
              <Card className={classes.card}>
                <Box
                  className={classes.thumbnailWrapper}
                  onClick={() => setSelectedVideo(video)}
                >
                  <CardMedia
                    component="img"
                    image={video.thumbnail}
                    alt={video.title}
                    className={classes.thumbnail}
                  />
                  {/*<iframe
                    className={classes.thumbnail}
                    src="https://www.youtube.com/embed/bjnFacXst5w?si=Pgd57OAebPAC03zj"
                    title="Ryan Taft: Best Practices for Lead Follow-up"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen></iframe>*/}
                  {/*<Box className={classes.overlay}>
                    <Box className={classes.playButton}>
                      <PlayArrow style={{color: "white", fontSize: 32}}/>
                    </Box>
                  </Box>*/}
                  <Box className={classes.metadataOverlay}>
                    <Chip label={video.category} color="primary" size="small" />
                    {/*<Box className={classes.durationChip}>
                      <AccessTime style={{fontSize: 14}}/>
                      <Typography variant="body2">{video.duration}</Typography>
                    </Box>*/}
                  </Box>
                </Box>

                <CardContent className={classes.cardContent}>
                  {/* Row 1: Video Title */}
                  <Typography variant="h6" className={classes.videoTitle}>
                    {video.title}
                  </Typography>

                  {/* Row 2: Creator Info */}
                  <Box className={classes.creatorInfo}>
                    <Avatar
                      src={video.creator.avatar}
                      alt={video.creator.name}
                      className={classes.creatorAvatar}
                    />
                    <Box className={classes.creatorTextContent}>
                      <Box className={classes.creatorText}>
                        <Typography variant="subtitle2" color="primary">
                          {video.creator.name}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          • {video.date}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  {/* Row 3: Company Info */}
                  <Box className={classes.companyInfo}>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        flex: 1
                      }}
                    >
                      {video.creator.title} at{" "}
                      <a
                        href={video.creator.companyUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "inherit",
                          textDecoration: "underline"
                        }}
                      >
                        {video.creator.company}
                      </a>
                    </Typography>
                    <a
                      href={video.creator.companyUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={getLogoClass(video)}
                    >
                      <img
                        src={video.creator.companyLogo}
                        alt={video.creator.company}
                        style={{
                          height: "20px",
                          width: "auto",
                          flexShrink: 0
                        }}
                      />
                    </a>
                  </Box>

                  {/* Row 4: Description */}
                  <Typography
                    variant="body2"
                    className={classes.videoDescription}
                  >
                    {video.description}
                  </Typography>

                  {/* Row 5: Action Buttons */}
                  <Box className={classes.actionButtons}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => setSelectedVideo(video)}
                      className={classes.watchVideoButton}
                    >
                      Watch Video
                    </Button>
                    <Button
                      variant="outlined"
                      color="primary"
                      startIcon={<CalendarToday />}
                      onClick={() => setShowConsultation(true)}
                      className={classes.ScheduleButton}
                    >
                      Schedule Consultation
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Video Dialog */}
      <Dialog
        open={!!selectedVideo}
        onClose={() => setSelectedVideo(null)}
        maxWidth="lg"
        fullWidth
      >
        {selectedVideo && (
          <>
            <DialogContent style={{ padding: 0 }}>
              <Grid container>
                <Grid item xs={12} md={8}>
                  <Box style={{ position: "relative", paddingTop: "56.25%" }}>
                    {/*<video
                      src={selectedVideo.videoUrl}
                      controls
                      autoPlay
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%"
                      }}
                    />*/}
                    <iframe
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%"
                      }}
                      src={`${selectedVideo.videoUrl}&autoplay=1&rel=0`}
                      title={selectedVideo.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                    ></iframe>
                  </Box>
                  <Box
                    padding={3}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px"
                    }}
                  >
                    <Typography variant="h5">{selectedVideo.title}</Typography>
                    <Box
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "10px"
                      }}
                    >
                      <Chip
                        label={selectedVideo.category}
                        color="primary"
                        size="small"
                      />
                    </Box>
                    <Typography variant="body2" color="textSecondary">
                      {selectedVideo.description}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} md={4}>
                  <Box
                    padding={3}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyItems: "center",
                      gap: "10px"
                    }}
                  >
                    <Avatar
                      src={selectedVideo.creator.avatar}
                      alt={selectedVideo.creator.name}
                      style={{
                        width: 96,
                        height: 96,
                        border: "4px solid #f97316",
                        marginBottom: 16
                      }}
                    />
                    <Typography variant="h6">
                      {selectedVideo.creator.name}
                    </Typography>
                    <Typography variant="subtitle1" color="primary">
                      {selectedVideo.creator.title}
                    </Typography>
                    <a
                      href={selectedVideo.creator.companyUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={getLogoClass(selectedVideo)}
                    >
                      <img
                        src={selectedVideo.creator.companyLogo}
                        alt={selectedVideo.creator.company}
                        style={{ margin: "16px auto", height: 32 }}
                      />
                    </a>

                    <Typography variant="body2" color="textSecondary">
                      {selectedVideo.creator.description}
                    </Typography>
                    <Box
                      display="flex"
                      flexDirection="column"
                      marginTop={2}
                      style={{
                        width: "100%"
                      }}
                    >
                      <Box mb={2}>
                        <Button
                          variant="contained"
                          color="primary"
                          startIcon={<GetApp />}
                          className={classes.modalDownloadButton}
                        >
                          Download Resources
                        </Button>
                      </Box>
                      <Button
                        variant="outlined"
                        color="primary"
                        startIcon={<CalendarToday />}
                        className={classes.modalScheduleButton}
                        onClick={() => {
                          setSelectedVideo(null);
                          setShowConsultation(true);
                        }}
                      >
                        Schedule Consultation
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <IconButton className={classes.closeButton} onClick={() => setSelectedVideo(null)}>
                <Close />
              </IconButton>
            </DialogActions>
          </>
        )}
      </Dialog>

      {/* Consultation Form Dialog */}
      <Dialog
        open={showConsultation}
        onClose={() => setShowConsultation(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Schedule a Consultation</DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmitConsultation}>
            <TextField fullWidth label="Full Name" required margin="normal" />
            <TextField fullWidth label="Email" required margin="normal" />
            <TextField
              fullWidth
              label="Phone Number"
              required
              margin="normal"
            />
            <TextField fullWidth label="Company" required margin="normal" />
            <TextField
              fullWidth
              type="date"
              label="Preferred Date"
              InputLabelProps={{ shrink: true }}
              required
              margin="normal"
            />
            <FormControl fullWidth margin="normal">
              <InputLabel>Preferred Time</InputLabel>
              <Select defaultValue="">
                <MenuItem value="morning">Morning (9AM - 12PM)</MenuItem>
                <MenuItem value="afternoon">Afternoon (1PM - 5PM)</MenuItem>
                <MenuItem value="evening">Evening (6PM - 8PM)</MenuItem>
              </Select>
            </FormControl>
            <TextField
              fullWidth
              label="Additional Info"
              multiline
              rows={3}
              margin="normal"
            />
            <DialogActions>
              <Button onClick={() => setShowConsultation(false)}>Cancel</Button>
              <Button type="submit" variant="contained" color="primary">
                Submit
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default SalesTraining;
